import { useQuery } from '@tanstack/react-query';
import { useSelector } from 'react-redux';

import { turbinesKey } from '../../../solaris-lens-common-lib/src/constants/queryKeys/Turbines';
import { patchTurbineHistorySeries } from '../../../solaris-lens-common-lib/src/services/installedProducts';
import { RootState } from '../../../store';
import useShouldRefresh from '@/hooks/useShouldRefresh';

export interface TurbineHistorySeriesMetric {
  id: string;
  scope: string;
  category: string;
  label?: string;
}

export interface TurbineSeriesMetricError {
  metric: string;
  errorMessage: string;
  technicalMessage?: string;
}

export interface TurbineSeriesError {
  id: string;
  errorMessage: string;
  details: {
    errors: TurbineSeriesMetricError[];
  };
}

export interface TurbineHistorySeriesParams {
  turbineId: string;
  startDate: string;
  endDate: string;
  interval?: string;
  applyDateFormat?: boolean;
  metrics: TurbineHistorySeriesMetric[];
}

export const useTurbineHistorySeries = (
  params: TurbineHistorySeriesParams,
  { useQueryOptions = {} } = {}
) => {
  const token = useSelector((state: RootState) => state?.auth?.accessToken);
  useShouldRefresh();

  const { metrics, ...queryParams } = params;

  return useQuery({
    queryKey: turbinesKey.historySeries(token, {
      ...queryParams,
      metrics,
      _variant: 'patch'
    }),
    queryFn: async () => {
      const data = await patchTurbineHistorySeries({
        token,
        params: queryParams,
        body: { metrics }
      });
      return data;
    },
    enabled: Boolean(token && params.turbineId && params.metrics?.length),
    ...useQueryOptions
  });
};
